import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

interface Props {
  secondsRemaining: number;
}

export function SessionExpiryWarning({ secondsRemaining: initial }: Props) {
  const [secs, setSecs] = useState(initial);

  useEffect(() => {
    setSecs(initial);
    const iv = setInterval(() => setSecs((s) => Math.max(0, s - 1)), 1_000);
    return () => clearInterval(iv);
  }, [initial]);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-background rounded-xl shadow-xl border p-6 max-w-sm w-full mx-4 space-y-4 text-center">
        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-amber-100 text-amber-600 mx-auto">
          <Clock className="h-6 w-6" />
        </div>
        <div className="space-y-1">
          <h2 className="text-lg font-semibold">Session expiring soon</h2>
          <p className="text-sm text-muted-foreground">
            You'll be signed out in{" "}
            <span className="font-bold text-foreground tabular-nums">{secs}s</span> due to
            inactivity.
          </p>
        </div>
        <p className="text-xs text-muted-foreground">
          Move your mouse or press any key to stay signed in.
        </p>
      </div>
    </div>
  );
}
